module.exports = __webpack_public_path__ + "static/media/layout-single.7c77d1c1.svg";